import React, { useState, useEffect, useCallback } from "react";
import { useRecoilState } from "recoil";
import RegionForm from "./RegionForm";
import useDeleteRegion from "./hooks/useDeleteRegion";
import useUpdateRegion from "./hooks/useUpdateRegion";
import {
  addStateRegion,
  selectedRowsStateRegion,
  setFilterTextRegion,
  editStateRegion,
  rowForEditStateRegion,
  setCheckStatusStateRegion,
  disableButtonStateRegion,
  rowEditIdStateRegion,
  setButtonLinkTextStateRegion,
  setLinkStateRegion,
  setHierarchyIdStateRegion,
  setDescriptionRegionState,
} from "../../OfficeHierarchy/Region/atoms/atoms";
import { officeHierarchyShowState } from "./../atoms/atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import useGetEmployees from "./hooks/useGetEmployees";
import { getHierarchyType } from "./../atoms/atoms";
import { useOfficeHierarchyChildByTypeId } from "../hooks/useOfficeHierarchyChildByTypeId";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
const RegionTable = ({ regionRowData, onClickOfficeHierarchyName }) => {
  //Hooks Call

  const { data, isFetching } = useOfficeHierarchyChildByTypeId(
    "Region (Market)",
    regionRowData.idC
  );

  const UpdateRegion = useUpdateRegion();
  const BulkDeleteRegion = useDeleteRegion();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateRegion);
  const [, setDescription] = useRecoilState(setDescriptionRegionState);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateRegion
  );
  const [rowsCount, setRowsCount] = useState(0);
  const [rowForEdit, setRowForEdit] = useRecoilState(rowForEditStateRegion);
  const [filterText, setFilterText] = useRecoilState(setFilterTextRegion);
  const [editRowId, setEditRowId] = useRecoilState(rowEditIdStateRegion);
  const [actionEditState, setActionEditState] = useRecoilState(editStateRegion);
  const [disabledButton, setDisabledButton] = useRecoilState(
    disableButtonStateRegion
  );

  const [checkStatus, setCheckStatus] = useRecoilState(
    setCheckStatusStateRegion
  );

  const [, setButtonTextLinkState] = useRecoilState(
    setButtonLinkTextStateRegion
  );
  const [, setButtonLinkState] = useRecoilState(setLinkStateRegion);
  const [, setHierarchyId] = useRecoilState(setHierarchyIdStateRegion);
  //Local States
  const [empTypeIsExist, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasRegion, setHasRegion] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [displayNote, setDisplayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const userAccount = useRecoilState(accountAtom);
  const [regionFilteredData, setRegionFilteredData] = useState([]);
  const employeeList = useGetEmployees();

  const viewPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_region_view;

  const defaultValues = {
    regionId: 0,
    regionCode: "",
    regionName: "",
    regionManager: "",
    managerEmail: "",
    managerUltiproNumber: "",
    regionId: 0,
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    isActive: 0,
  };
  const [, setType] = useRecoilState(getHierarchyType);
  const [empNewData] = useState([defaultValues]);
  const editPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_region_edit;
  const addPermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_region_add;
  const deletePermission =
    PERMISSIONS.permission_utilities_officehierarchyconfiguration_region_delete;
  const userPermissions = useRecoilValue(permissionsSelector);
  const [isShow, setShowState] = useRecoilState(officeHierarchyShowState);
  const [rowViewData, setRowViewData] = useState();
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state === null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent != "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setRegionFilteredData(result);
          setButtonTextLinkState(recordIdFromRecent.subModuleName);
          if (
            recordIdFromRecent.subModuleName === "Add" ||
            recordIdFromRecent.subModuleName === "Edit"
          ) {
            setType(recordIdFromRecent.selectedType);
            setDescription(recordIdFromRecent.description);
            setHierarchyId(recordIdFromRecent.hierarchyId);
            setActionAddState(true);
            setButtonLinkState(true);
          }
          history.replace();
        });
      } catch (error) {
        //console.log("error " + error);
      }
    } else {
      setButtonLinkState(false);
      setButtonTextLinkState("");
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleEditButton = (rowData) => {
    setRegionFilteredData([]);
    setRowForEdit(rowData);
    setEditRowId(rowData.regionId);
    setEmpTypeDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    sethideColumn(true);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.regionId);
    BulkDeleteRegion(ids);
    setActionEditState(false);
    setActionAddState(false);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Regions" : "Region"
    } ?`}</div>
  );

  const matColumns = [
    {
      title: "Name",
      // headerStyle: { borderLeft: "4px solid #203A75" },
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => onClickOfficeHierarchyName(rowdata)}
          >
            <span className="blueAndBold underline ">
              {rowdata.officeHierarchyName}
            </span>
          </div>
        );
      },
      cellStyle: {
        textAlign: "left",
        width: "30%",
        fontSize: "12px",
      },
    },

    {
      title: "Type",
      field: "Type",
      hidden: hideColumn,
      render: (rowData) => {
        return <div className="font-sans mr-4 text-xs">{rowData.type}</div>;
      },
    },
    {
      title: "Code",
      field: "hierarchyCode",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans text-left mr-4 text-xs">
            {rowData.hierarchyCode}
          </div>
        );
      },
    },
    {
      title: "Manager",
      field: "regionManager",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans mr-4 text-xs">{rowData.managerName}</div>
        );
      },
    },
    {
      title: "Is Active",
      field: "status",
      render: (rowData) => {
        return (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              <input
                data-tip={""}
                disabled={true}
                data-for={"status"}
                type="checkbox"
                className="w-4 h-4 bg-white shadow cursor-pointer mt-1"
                defaultChecked={rowData.isActive === "Active" ? true : false}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Record Type",
      field: "recordType",
      hidden: hideColumn,
      render: (rowData) => {
        return (
          <div className="font-sans mr-4 text-xs">{rowData.recordType}</div>
        );
      },
    },
    // {
    //   title: "Action/s",
    //   align: "center",
    //   render: (rowData) => {
    //     return (
    //       <div className="grid grid-col-1 justify-items-center mr-6">
    //         {userPermissions.includes(editPermission) ? (
    //           <Button
    //             disabled={disabledButton || selectedRows.length > 0}
    //             className={
    //               disabledButton || selectedRows.length > 0
    //                 ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
    //                : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
    //             }
    //             onClickFunction={() => {
    //               //setDisabledButton(true);
    //               setActionEditState(true);
    //               handleEditButton(rowData);
    //             }}
    //           >
    //             <PencilSquareIcon className="h-4 w-4" />
    //             <div>Edit</div>
    //           </Button>
    //         ): (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];

  //Filters
  const filteredItems = data
    ? data
    : // .filter(
      //     (item) =>
      //       item.regionName &&
      //       item.regionName.toLowerCase().includes(filterText.toLowerCase())
      //   )
      [];
  return (
    <div className="">
      <div className="">
        {!actionAddState && !actionEditState && (
          <div className="">
            <div className="flex w-full">
              <div className="bg-white w-full">
                {/* <div className="font-bold text-primary text-xl uppercase mx-4 ">
                  {" "}
                  <h1>Region</h1>{" "}
                </div> */}
                <div className="flex justify-between text-xs items-center w-full px-4 mt-2">
                  <div className="">
                    {/* <TableFilters
                      filterText={setFilterText}
                      moduleDetails="Region Name"
                      textInputName="RegionName"
                      disabledButton={disabledButton || selectedRows.length > 0}
                    ></TableFilters> */}
                  </div>
                  {/* <div className="">
                    {userPermissions.includes(addPermission) ? (
                      <AddButton
                        buttonText="New Region"
                        className={
                          selectedRows.length > 0 || actionEditState
                            ? "opacity-50"
                           : "opacity-100"
                        }
                        onClick={() => setActionAddState(!actionAddState)}
                        disabled={disabledButton}
                      />
                    ): (
                      ""
                    )}
                  </div> */}
                </div>
                <div>
                  {/* {userPermissions.includes(deletePermission) &&
                  !displayNote ? (
                    <div className="text-secondary italic text-xs3  mt-2 mx-4 ">
                      {!actionEditState ? (
                        <div>
                          <p className="font-bold italic inline-block mr-1">
                            Note:{" "}
                          </p>
                          Tick the box to deactivate some data.
                        </div>
                      ): (
                        <div></div>
                      )}
                    </div>
                  ): (
                    ""
                  )} */}
                </div>
                <div className="p-4">
                  <MaterialExTable
                    columns={matColumns}
                    data={
                      data
                      // ? regionFilteredData.length > 0
                      //   ? regionFilteredData
                      //  : filterText === ""
                      //     ? data.map((data) => ({ ...data }))
                      //    : filteredItems
                      //: []
                    }
                    options={{
                      toolbar: false,
                      showTitle: false,
                    }}
                    setOpenModal={setOpenModalDelete}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRows}
                    isDeactivate={true}
                    isLoading={isFetching}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {actionAddState && (
          <div className="">
            <RegionForm employeeList={employeeList} />
          </div>
        )}
        {actionEditState && (
          <div className="">
            <RegionForm employeeList={employeeList} />
          </div>
        )}
      </div>
    </div>
  );
};

export default RegionTable;
